import { useState, useEffect } from 'react';

const appendScript = async (src)=>{
    if (document.querySelectorAll(`script[src="${src}"]`).length) {
        return;
    }
    const tag = document.createElement('script');
    tag.src = src;
    tag.async = true;
    document.body.appendChild(tag);
};
// Initialize custom event for wistia
if (typeof window !== 'undefined') {
    window['_wq'] = window['_wq'] || [];
    window['_wq'].push({
        id: '_all',
        onReady: ()=>{
            document.dispatchEvent(new Event('wistia_loaded'));
        }
    });
}
const classnames = {
    thumbnail: 'wistia_thumbnail',
    responsiveWrapper: 'wistia_responsive_wrapper',
    deferred: 'wistia_deferred',
    embed: 'wistia_embed',
    swatch: 'wistia_swatch',
    background: 'background',
    async: (id)=>`wistia_async_${id}`
};
const wistiaFlags = {
    noSEO: 'seo=false',
    videoFoam: 'videoFoam=true',
    autoPlay: 'autoPlay=true'
};
const initWistiaVideo = ({ wrapper, embedId = null, autoPlay = false, videoId = null, classes = [] })=>{
    if (!wrapper || wrapper.dataset.wistiaPrepared) {
        return;
    }
    const wistiaId = wrapper.dataset.wistiaVideoId || videoId;
    if (wistiaId) {
        appendWistiaScript();
        wrapper.dataset.wistiaPrepared = 'true';
        const wrapperIsDeferred = wrapper.classList.contains(classnames.deferred);
        const embedClasses = [
            classnames.embed,
            classnames.async(wistiaId),
            wistiaFlags.noSEO,
            wistiaFlags.videoFoam
        ];
        if (classes.length) {
            embedClasses.push(...classes);
        }
        if (autoPlay || wrapperIsDeferred) {
            embedClasses.push(wistiaFlags.autoPlay);
        }
        const embed = document.createElement('div');
        embed.classList.add(...embedClasses);
        const swatch = document.createElement('div');
        swatch.classList.add(classnames.swatch);
        swatch.style.cssText = 'height:100%;left:0;opacity:0;overflow:hidden;position:absolute;top:0;transition:opacity 200ms;width:100%;';
        wrapper.appendChild(embed).appendChild(swatch);
        wrapper.dataset.testid = 'wistia-element-ref';
        if (embedId) {
            embed.id = embedId;
        }
    }
};
// Wistia hook so we can have easy access to "onReady" listener and get the video api
const useWistiaVideoApi = ({ id, jsonp, onReady, options = {} })=>{
    const [videoApi, setVideoApi] = useState();
    useEffect(()=>{
        window['_wq'] = window['_wq'] || [];
        window['_wq'].push({
            id,
            onReady: (api)=>{
                setVideoApi(api);
                {
                    appendWistiaJsonpScript(id);
                }
                return api;
            },
            options
        });
    }, []);
    return videoApi;
};
const appendWistiaScript = ()=>{
    appendScript('https://fast.wistia.com/assets/external/E-v1.js');
};
const appendWistiaJsonpScript = (id)=>{
    appendScript(`https://fast.wistia.com/embed/medias/${id}.jsonp`);
};

export { appendWistiaJsonpScript, appendWistiaScript, initWistiaVideo, useWistiaVideoApi };
